var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Ptable',{ref:"childrenTable",attrs:{"tabShow":'all',"tableData":_vm.tableData,"totalNum":_vm.totalNum,"dialogVisible":_vm.dialogVisible,"loading":_vm.loading},on:{"handleClick":_vm.handleClick,"child-event":_vm.getLists}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }